import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken } from "@angular/common/http";
import { Observable } from "rxjs";
import { ActivationEnd, Router } from "@angular/router";
import { HttpcancelService } from "./httpcancel.service";
import { takeUntil } from "rxjs/operators";

// Opt-out for background work that isn't tied to the route that started it (e.g. fired from a resolver).
export const SURVIVES_ROUTE_CHANGE = new HttpContextToken<boolean>(() => false);

@Injectable()
export class CancelhttpbetweenroutesInterceptor implements HttpInterceptor {
  constructor(router: Router, private cancelHttpService: HttpcancelService) {
    router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        // Cancel all PENDING calls
        this.cancelHttpService.cancelPendingRequests();
      }
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const req = next.handle(request);
    if (request.context.get(SURVIVES_ROUTE_CHANGE)) {
      return req;
    }
    const cancelledReq = this.cancelHttpService.onCancelPendingRequests();
    return req.pipe(takeUntil(cancelledReq));
  }
}
